import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import LabelList from '@chronos/components/LabelList';
import * as timeUtil from '@chronos/time-util';
import * as S from './styled';

const CardsListItem = ({
  card,
  estimates,
  totalTime,
  isLabelExpanded,
  onClickExpandLabel,
  getWhoisTracking,
  liveWorklogs,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const statsInfo = useMemo(() => {
    const trackedTime = totalTime ? timeUtil.stj(totalTime) : '';
    const arr = [];
    if (trackedTime) {
      arr.push(trackedTime);
    }

    if (estimates.length > 0) {
      const seconds = estimates.reduce(
        (acc, estimate) => acc + estimate.seconds,
        0
      );
      arr.push(`est. ${timeUtil.stj(seconds)}`);
    }
    return arr.join(' / ');
  }, [totalTime, estimates]);

  const handleClick = useCallback(() => {
    const state = { backgroundLocation: location };
    navigate(`/${card.idBoard}/cards/${card.id}`, { state });
  }, []);

  const whoisTracking = useMemo(() => {
    return getWhoisTracking(card.id);
  }, [card.id, liveWorklogs]);

  return (
    <div
      onClick={handleClick}
      key={card.id}
    >
      <S.CardsListItem>
        {card.labels?.length > 0 && (
          <LabelList
            isExpanded={isLabelExpanded}
            labels={card.labels}
            onExpand={onClickExpandLabel}
          />
        )}

        <S.CardName>{card.name}</S.CardName>

        {whoisTracking && (
          <S.WhoisTrackingText>{getWhoisTracking(card.id)}</S.WhoisTrackingText>
        )}
        {statsInfo && (
          <S.ListItemStats>
            <S.ListItemStatsIcon />
            <S.ListItemStatsText>{statsInfo}</S.ListItemStatsText>
          </S.ListItemStats>
        )}
      </S.CardsListItem>
    </div>
  );
};

CardsListItem.defaultProps = {
  estimates: [],
  totalTime: null,
};

CardsListItem.propTypes = {
  card: PropTypes.object.isRequired,
  estimates: PropTypes.array,
  totalTime: PropTypes.number,
  isLabelExpanded: PropTypes.bool.isRequired,
  onClickExpandLabel: PropTypes.func.isRequired,
  getWhoisTracking: PropTypes.func,
};

export default CardsListItem;
